import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  CardMedia,
  Box,
  styled,
} from "@mui/material";
import React from "react";
import { convertToSentenceCase, getImageFolder } from "../Utils/utils";

const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  // "& .MuiCardHeader-title": {
  //   fontSize: "1px",
  // },
  // "& .MuiCardHeader-subheader": {
  //   fontSize: "1px",
  // },
}));

export const ProductItemXL = (props) => {
  const { name, description, price, imageUrl, onOpen, rows } = props;
  return (
    <Grid
      item
      xs={12}
      sm={rows ? rows : 6}
      md={rows ? rows : 4}
      lg={rows ? rows : 3}
      xl={rows ? rows : 3}
      sx={{ width: "100%" }}
    >
      <Card
        onClick={(e) => onOpen()}
        sx={{
          height: "445px",
          maxHeight: "445px",
          maxWidth: "520px",
        }}
      >
        <StyledCardHeader
          title={name}
          subheader={price.toFixed(2) > 0 ? `$${price.toFixed(2)}` : ""}
          sx={{
            paddingLeft: "16px",
            paddingTop: "16px",
            paddingRight: "16px",
            paddingBottom: "0px",
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: "300px",
            width: "300px",
            margin: "auto",
          }}
        >
          <CardMedia
            component="img"
            image={`${getImageFolder()}/images/md_${imageUrl}`}
            alt={name}
            style={{
              maxWidth: "488px",
              maxHeight: "288px",
              width: "auto",
              height: "auto",
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = `${getImageFolder()}/images/no-image-icon-6.png`;
            }}
          />
        </div>
        <CardContent
          sx={{ paddingTop: "0px", width: "300px", overflowY: "hidden" }}
        >
          <Typography
            noWrap
            variant="body2"
            color="text.secondary"
            sx={{ width: "100%" }}
          >
            {description ? description.substring(0, 80) : description}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};
